import { all, put, call, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { emailInvite, fundingReport as fundingReportType, inviteLink } from './types';

import {
  requestFundingReportSuccess,
  requestFundingReportFailure,
  requestInviteLinkSuccess,
  requestInviteLinkFailure,
} from './reducer';

import convertToFundingSearchSaga from './convertToFundingSearch/sagas';
import deleteFundingReportSaga from './delete/sagas';
import fundingReportListSaga from './list/sagas';
import fundingReportMatchesSaga from './matches/sagas';
import resendInviteSaga from './resendInvite/sagas';

const logger = new Logger('Saga:FundingReport');

export function* requestFundingReportSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');
  const { reportId } = action;

  try {
    const response = yield call(
      authApiService.get,
      routerService.generate('api.funding_report_detail', { reportId }),
    );

    yield put(requestFundingReportSuccess(response.data));
  } catch (error) {
    logger.error('Failed to request funding report with the following error', error);
    yield put(requestFundingReportFailure(error));
  }
}

export function* requestEmailInviteSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.post,
      routerService.generate('api.create_funding_report'),
      { ...action.payload },
    );

    action.promise && action.promise.resolve(response.data);
  } catch (error) {
    logger.error('Failed to request email invite with the following error', error);
    action.promise && action.promise.reject(error);
  }
}

export function* requestInviteLinkSaga() {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.get,
      routerService.generate('api.funding_report_invite_url'),
    );

    yield put(requestInviteLinkSuccess(response.data.url));
  } catch (error) {
    logger.error('Failed to request invite link with the following error', error);
    yield put(requestInviteLinkFailure(error));
  }
}

export default function* fundingReportSaga() {
  return yield all([
    takeLatest(fundingReportType.request, requestFundingReportSaga),
    takeLatest(emailInvite.request, requestEmailInviteSaga),
    takeLatest(inviteLink.request, requestInviteLinkSaga),
    convertToFundingSearchSaga(),
    deleteFundingReportSaga(),
    fundingReportListSaga(),
    fundingReportMatchesSaga(),
    resendInviteSaga(),
  ]);
}
